module.exports = __webpack_public_path__ + "static/img/8.04c4f6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/eng/8.png
// module id = zzRR
// module chunks = 0